/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedBalanceRouteImport } from './routes/_authenticated/balance'
import { Route as AuthenticatedDocumentsRouteImport } from './routes/_authenticated/documents'
import { Route as AuthenticatedOnboardingRouteImport } from './routes/_authenticated/onboarding'
import { Route as AuthenticatedOpportunitiesRouteImport } from './routes/_authenticated/opportunities'
import { Route as AuthenticatedReferralsRouteImport } from './routes/_authenticated/referrals'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedSpreadsRouteImport } from './routes/_authenticated/spreads'
import { Route as AuthenticatedTradeRouteImport } from './routes/_authenticated/trade'
import { Route as AuthenticatedYieldRouteImport } from './routes/_authenticated/yield'
import { Route as UnauthenticatedEmailVerificationRouteImport } from './routes/_unauthenticated/email-verification'
import { Route as UnauthenticatedForgotPasswordRouteImport } from './routes/_unauthenticated/forgot-password'
import { Route as UnauthenticatedSignInRouteImport } from './routes/_unauthenticated/sign-in'
import { Route as UnauthenticatedSignUpRouteImport } from './routes/_unauthenticated/sign-up'
import { Route as UnauthenticatedSignupInterestConfirmationRouteImport } from './routes/_unauthenticated/signup-interest-confirmation'
import { Route as AuthenticatedBalanceIndexRouteImport } from './routes/_authenticated/balance/index'
import { Route as AuthenticatedBalancePremiumsRouteImport } from './routes/_authenticated/balance/premiums'
import { Route as AuthenticatedDocumentsIndexRouteImport } from './routes/_authenticated/documents/index'
import { Route as AuthenticatedDocumentsActivityRouteImport } from './routes/_authenticated/documents/activity'
import { Route as AuthenticatedDocumentsNotificationRouteImport } from './routes/_authenticated/documents/notification'
import { Route as AuthenticatedDocumentsStatementRouteImport } from './routes/_authenticated/documents/statement'
import { Route as AuthenticatedOnboardingIndexRouteImport } from './routes/_authenticated/onboarding/index'
import { Route as AuthenticatedOnboardingStepRouteImport } from './routes/_authenticated/onboarding/$step'
import { Route as AuthenticatedOnboardingDocsRouteImport } from './routes/_authenticated/onboarding/docs'
import { Route as AuthenticatedOnboardingSuccessRouteImport } from './routes/_authenticated/onboarding/success'
import { Route as AuthenticatedOpportunitiesIndexRouteImport } from './routes/_authenticated/opportunities/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsCookiesRouteImport } from './routes/_authenticated/settings/cookies'
import { Route as AuthenticatedSettingsMfaRouteImport } from './routes/_authenticated/settings/mfa'
import { Route as AuthenticatedSettingsOnboardingRouteImport } from './routes/_authenticated/settings/onboarding'
import { Route as AuthenticatedSettingsPasswordRouteImport } from './routes/_authenticated/settings/password'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedTradeIndexRouteImport } from './routes/_authenticated/trade/index'
import { Route as AuthenticatedTradeMetalTransferRouteImport } from './routes/_authenticated/trade/metal-transfer'
import { Route as AuthenticatedTradePurchaseRouteImport } from './routes/_authenticated/trade/purchase'
import { Route as AuthenticatedTradeShipMetalRouteImport } from './routes/_authenticated/trade/ship-metal'
import { Route as AuthenticatedTradeWithdrawRouteImport } from './routes/_authenticated/trade/withdraw'
import { Route as AuthenticatedOpportunitiesUnsecuredLeaseInstanceRouteImport } from './routes/_authenticated/opportunities/unsecured/$leaseInstance'
import { Route as AuthenticatedSettingsPaymentMethodsIndexRouteImport } from './routes/_authenticated/settings/payment-methods/index'
import { Route as AuthenticatedSettingsPaymentMethodsCallbackRouteImport } from './routes/_authenticated/settings/payment-methods/callback'
import { Route as AuthenticatedTradePendingIndexRouteImport } from './routes/_authenticated/trade/pending/index'
import { Route as AuthenticatedTradePendingTaskIdRouteImport } from './routes/_authenticated/trade/pending/$taskId'
import { Route as AuthenticatedTradePurchaseIndexRouteImport } from './routes/_authenticated/trade/purchase/index'
import { Route as AuthenticatedTradeSendVaultTransferRouteImport } from './routes/_authenticated/trade/send/vault-transfer'
import { Route as AuthenticatedTradeShipMetalIndexRouteImport } from './routes/_authenticated/trade/ship-metal/index'
import { Route as AuthenticatedTradeShipMetalPackingSlipRouteImport } from './routes/_authenticated/trade/ship-metal/packing-slip'
import { Route as AuthenticatedTradeShipMetalProductListRouteImport } from './routes/_authenticated/trade/ship-metal/product-list'
import { Route as AuthenticatedTradeShipMetalSignatureRouteImport } from './routes/_authenticated/trade/ship-metal/signature'
import { Route as AuthenticatedTradeWithdrawIndexRouteImport } from './routes/_authenticated/trade/withdraw/index'
import { Route as AuthenticatedTradeWithdrawSplatRouteImport } from './routes/_authenticated/trade/withdraw/$'
import { Route as AuthenticatedSettingsPaymentMethodsNewIndexRouteImport } from './routes/_authenticated/settings/payment-methods/new/index'
import { Route as AuthenticatedSettingsPaymentMethodsNewFinalStepsRouteImport } from './routes/_authenticated/settings/payment-methods/new/final-steps'
import { Route as AuthenticatedTradePurchaseRecurringIndexRouteImport } from './routes/_authenticated/trade/purchase/recurring/index'
import { Route as AuthenticatedTradePurchaseRecurringNewRouteImport } from './routes/_authenticated/trade/purchase/recurring/new'
import { Route as AuthenticatedTradeWithdrawCashIndexRouteImport } from './routes/_authenticated/trade/withdraw/cash/index'
import { Route as AuthenticatedTradeWithdrawCashPayoutRouteImport } from './routes/_authenticated/trade/withdraw/cash/payout'
import { Route as AuthenticatedTradeWithdrawCashReviewRouteImport } from './routes/_authenticated/trade/withdraw/cash/review'
import { Route as AuthenticatedTradeWithdrawProductsIndexRouteImport } from './routes/_authenticated/trade/withdraw/products/index'
import { Route as AuthenticatedTradeWithdrawProductsReviewRouteImport } from './routes/_authenticated/trade/withdraw/products/review'
import { Route as AuthenticatedTradeWithdrawProductsShippingRouteImport } from './routes/_authenticated/trade/withdraw/products/shipping'
import { Route as AuthenticatedTradeWithdrawProductsSignatureRouteImport } from './routes/_authenticated/trade/withdraw/products/signature'
import { Route as AuthenticatedTradePurchaseRecurringEditScheduleIdRouteImport } from './routes/_authenticated/trade/purchase/recurring/edit.$scheduleId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
  id: '/_unauthenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBalanceRoute = AuthenticatedBalanceRouteImport.update({
  id: '/balance',
  path: '/balance',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedDocumentsRoute = AuthenticatedDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOnboardingRoute = AuthenticatedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedOpportunitiesRoute =
  AuthenticatedOpportunitiesRouteImport.update({
    id: '/opportunities',
    path: '/opportunities',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedReferralsRoute = AuthenticatedReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSpreadsRoute = AuthenticatedSpreadsRouteImport.update({
  id: '/spreads',
  path: '/spreads',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTradeRoute = AuthenticatedTradeRouteImport.update({
  id: '/trade',
  path: '/trade',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedYieldRoute = AuthenticatedYieldRouteImport.update({
  id: '/yield',
  path: '/yield',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const UnauthenticatedEmailVerificationRoute =
  UnauthenticatedEmailVerificationRouteImport.update({
    id: '/email-verification',
    path: '/email-verification',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedForgotPasswordRoute =
  UnauthenticatedForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const UnauthenticatedSignInRoute = UnauthenticatedSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedSignUpRoute = UnauthenticatedSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => UnauthenticatedRoute,
} as any)
const UnauthenticatedSignupInterestConfirmationRoute =
  UnauthenticatedSignupInterestConfirmationRouteImport.update({
    id: '/signup-interest-confirmation',
    path: '/signup-interest-confirmation',
    getParentRoute: () => UnauthenticatedRoute,
  } as any)
const AuthenticatedBalanceIndexRoute =
  AuthenticatedBalanceIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBalanceRoute,
  } as any)
const AuthenticatedBalancePremiumsRoute =
  AuthenticatedBalancePremiumsRouteImport.update({
    id: '/premiums',
    path: '/premiums',
    getParentRoute: () => AuthenticatedBalanceRoute,
  } as any)
const AuthenticatedDocumentsIndexRoute =
  AuthenticatedDocumentsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedDocumentsActivityRoute =
  AuthenticatedDocumentsActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedDocumentsNotificationRoute =
  AuthenticatedDocumentsNotificationRouteImport.update({
    id: '/notification',
    path: '/notification',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedDocumentsStatementRoute =
  AuthenticatedDocumentsStatementRouteImport.update({
    id: '/statement',
    path: '/statement',
    getParentRoute: () => AuthenticatedDocumentsRoute,
  } as any)
const AuthenticatedOnboardingIndexRoute =
  AuthenticatedOnboardingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedOnboardingStepRoute =
  AuthenticatedOnboardingStepRouteImport.update({
    id: '/$step',
    path: '/$step',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedOnboardingDocsRoute =
  AuthenticatedOnboardingDocsRouteImport.update({
    id: '/docs',
    path: '/docs',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedOnboardingSuccessRoute =
  AuthenticatedOnboardingSuccessRouteImport.update({
    id: '/success',
    path: '/success',
    getParentRoute: () => AuthenticatedOnboardingRoute,
  } as any)
const AuthenticatedOpportunitiesIndexRoute =
  AuthenticatedOpportunitiesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOpportunitiesRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsCookiesRoute =
  AuthenticatedSettingsCookiesRouteImport.update({
    id: '/cookies',
    path: '/cookies',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsMfaRoute =
  AuthenticatedSettingsMfaRouteImport.update({
    id: '/mfa',
    path: '/mfa',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsOnboardingRoute =
  AuthenticatedSettingsOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsPasswordRoute =
  AuthenticatedSettingsPasswordRouteImport.update({
    id: '/password',
    path: '/password',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedTradeIndexRoute = AuthenticatedTradeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedTradeRoute,
} as any)
const AuthenticatedTradeMetalTransferRoute =
  AuthenticatedTradeMetalTransferRouteImport.update({
    id: '/metal-transfer',
    path: '/metal-transfer',
    getParentRoute: () => AuthenticatedTradeRoute,
  } as any)
const AuthenticatedTradePurchaseRoute =
  AuthenticatedTradePurchaseRouteImport.update({
    id: '/purchase',
    path: '/purchase',
    getParentRoute: () => AuthenticatedTradeRoute,
  } as any)
const AuthenticatedTradeShipMetalRoute =
  AuthenticatedTradeShipMetalRouteImport.update({
    id: '/ship-metal',
    path: '/ship-metal',
    getParentRoute: () => AuthenticatedTradeRoute,
  } as any)
const AuthenticatedTradeWithdrawRoute =
  AuthenticatedTradeWithdrawRouteImport.update({
    id: '/withdraw',
    path: '/withdraw',
    getParentRoute: () => AuthenticatedTradeRoute,
  } as any)
const AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute =
  AuthenticatedOpportunitiesUnsecuredLeaseInstanceRouteImport.update({
    id: '/unsecured/$leaseInstance',
    path: '/unsecured/$leaseInstance',
    getParentRoute: () => AuthenticatedOpportunitiesRoute,
  } as any)
const AuthenticatedSettingsPaymentMethodsIndexRoute =
  AuthenticatedSettingsPaymentMethodsIndexRouteImport.update({
    id: '/payment-methods/',
    path: '/payment-methods/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsPaymentMethodsCallbackRoute =
  AuthenticatedSettingsPaymentMethodsCallbackRouteImport.update({
    id: '/payment-methods/callback',
    path: '/payment-methods/callback',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedTradePendingIndexRoute =
  AuthenticatedTradePendingIndexRouteImport.update({
    id: '/pending/',
    path: '/pending/',
    getParentRoute: () => AuthenticatedTradeRoute,
  } as any)
const AuthenticatedTradePendingTaskIdRoute =
  AuthenticatedTradePendingTaskIdRouteImport.update({
    id: '/pending/$taskId',
    path: '/pending/$taskId',
    getParentRoute: () => AuthenticatedTradeRoute,
  } as any)
const AuthenticatedTradePurchaseIndexRoute =
  AuthenticatedTradePurchaseIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTradePurchaseRoute,
  } as any)
const AuthenticatedTradeSendVaultTransferRoute =
  AuthenticatedTradeSendVaultTransferRouteImport.update({
    id: '/send/vault-transfer',
    path: '/send/vault-transfer',
    getParentRoute: () => AuthenticatedTradeRoute,
  } as any)
const AuthenticatedTradeShipMetalIndexRoute =
  AuthenticatedTradeShipMetalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTradeShipMetalRoute,
  } as any)
const AuthenticatedTradeShipMetalPackingSlipRoute =
  AuthenticatedTradeShipMetalPackingSlipRouteImport.update({
    id: '/packing-slip',
    path: '/packing-slip',
    getParentRoute: () => AuthenticatedTradeShipMetalRoute,
  } as any)
const AuthenticatedTradeShipMetalProductListRoute =
  AuthenticatedTradeShipMetalProductListRouteImport.update({
    id: '/product-list',
    path: '/product-list',
    getParentRoute: () => AuthenticatedTradeShipMetalRoute,
  } as any)
const AuthenticatedTradeShipMetalSignatureRoute =
  AuthenticatedTradeShipMetalSignatureRouteImport.update({
    id: '/signature',
    path: '/signature',
    getParentRoute: () => AuthenticatedTradeShipMetalRoute,
  } as any)
const AuthenticatedTradeWithdrawIndexRoute =
  AuthenticatedTradeWithdrawIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradeWithdrawSplatRoute =
  AuthenticatedTradeWithdrawSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedSettingsPaymentMethodsNewIndexRoute =
  AuthenticatedSettingsPaymentMethodsNewIndexRouteImport.update({
    id: '/payment-methods/new/',
    path: '/payment-methods/new/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute =
  AuthenticatedSettingsPaymentMethodsNewFinalStepsRouteImport.update({
    id: '/payment-methods/new/final-steps',
    path: '/payment-methods/new/final-steps',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)
const AuthenticatedTradePurchaseRecurringIndexRoute =
  AuthenticatedTradePurchaseRecurringIndexRouteImport.update({
    id: '/recurring/',
    path: '/recurring/',
    getParentRoute: () => AuthenticatedTradePurchaseRoute,
  } as any)
const AuthenticatedTradePurchaseRecurringNewRoute =
  AuthenticatedTradePurchaseRecurringNewRouteImport.update({
    id: '/recurring/new',
    path: '/recurring/new',
    getParentRoute: () => AuthenticatedTradePurchaseRoute,
  } as any)
const AuthenticatedTradeWithdrawCashIndexRoute =
  AuthenticatedTradeWithdrawCashIndexRouteImport.update({
    id: '/cash/',
    path: '/cash/',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradeWithdrawCashPayoutRoute =
  AuthenticatedTradeWithdrawCashPayoutRouteImport.update({
    id: '/cash/payout',
    path: '/cash/payout',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradeWithdrawCashReviewRoute =
  AuthenticatedTradeWithdrawCashReviewRouteImport.update({
    id: '/cash/review',
    path: '/cash/review',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradeWithdrawProductsIndexRoute =
  AuthenticatedTradeWithdrawProductsIndexRouteImport.update({
    id: '/products/',
    path: '/products/',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradeWithdrawProductsReviewRoute =
  AuthenticatedTradeWithdrawProductsReviewRouteImport.update({
    id: '/products/review',
    path: '/products/review',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradeWithdrawProductsShippingRoute =
  AuthenticatedTradeWithdrawProductsShippingRouteImport.update({
    id: '/products/shipping',
    path: '/products/shipping',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradeWithdrawProductsSignatureRoute =
  AuthenticatedTradeWithdrawProductsSignatureRouteImport.update({
    id: '/products/signature',
    path: '/products/signature',
    getParentRoute: () => AuthenticatedTradeWithdrawRoute,
  } as any)
const AuthenticatedTradePurchaseRecurringEditScheduleIdRoute =
  AuthenticatedTradePurchaseRecurringEditScheduleIdRouteImport.update({
    id: '/recurring/edit/$scheduleId',
    path: '/recurring/edit/$scheduleId',
    getParentRoute: () => AuthenticatedTradePurchaseRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/balance': typeof AuthenticatedBalanceRouteWithChildren
  '/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/opportunities': typeof AuthenticatedOpportunitiesRouteWithChildren
  '/referrals': typeof AuthenticatedReferralsRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/spreads': typeof AuthenticatedSpreadsRoute
  '/trade': typeof AuthenticatedTradeRouteWithChildren
  '/yield': typeof AuthenticatedYieldRoute
  '/email-verification': typeof UnauthenticatedEmailVerificationRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/sign-in': typeof UnauthenticatedSignInRoute
  '/sign-up': typeof UnauthenticatedSignUpRoute
  '/signup-interest-confirmation': typeof UnauthenticatedSignupInterestConfirmationRoute
  '/balance/premiums': typeof AuthenticatedBalancePremiumsRoute
  '/documents/activity': typeof AuthenticatedDocumentsActivityRoute
  '/documents/notification': typeof AuthenticatedDocumentsNotificationRoute
  '/documents/statement': typeof AuthenticatedDocumentsStatementRoute
  '/onboarding/$step': typeof AuthenticatedOnboardingStepRoute
  '/onboarding/docs': typeof AuthenticatedOnboardingDocsRoute
  '/onboarding/success': typeof AuthenticatedOnboardingSuccessRoute
  '/settings/cookies': typeof AuthenticatedSettingsCookiesRoute
  '/settings/mfa': typeof AuthenticatedSettingsMfaRoute
  '/settings/onboarding': typeof AuthenticatedSettingsOnboardingRoute
  '/settings/password': typeof AuthenticatedSettingsPasswordRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/trade/metal-transfer': typeof AuthenticatedTradeMetalTransferRoute
  '/trade/purchase': typeof AuthenticatedTradePurchaseRouteWithChildren
  '/trade/ship-metal': typeof AuthenticatedTradeShipMetalRouteWithChildren
  '/trade/withdraw': typeof AuthenticatedTradeWithdrawRouteWithChildren
  '/balance/': typeof AuthenticatedBalanceIndexRoute
  '/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/opportunities/': typeof AuthenticatedOpportunitiesIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/trade/': typeof AuthenticatedTradeIndexRoute
  '/opportunities/unsecured/$leaseInstance': typeof AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute
  '/settings/payment-methods/callback': typeof AuthenticatedSettingsPaymentMethodsCallbackRoute
  '/trade/pending/$taskId': typeof AuthenticatedTradePendingTaskIdRoute
  '/trade/send/vault-transfer': typeof AuthenticatedTradeSendVaultTransferRoute
  '/trade/ship-metal/packing-slip': typeof AuthenticatedTradeShipMetalPackingSlipRoute
  '/trade/ship-metal/product-list': typeof AuthenticatedTradeShipMetalProductListRoute
  '/trade/ship-metal/signature': typeof AuthenticatedTradeShipMetalSignatureRoute
  '/trade/withdraw/$': typeof AuthenticatedTradeWithdrawSplatRoute
  '/settings/payment-methods/': typeof AuthenticatedSettingsPaymentMethodsIndexRoute
  '/trade/pending/': typeof AuthenticatedTradePendingIndexRoute
  '/trade/purchase/': typeof AuthenticatedTradePurchaseIndexRoute
  '/trade/ship-metal/': typeof AuthenticatedTradeShipMetalIndexRoute
  '/trade/withdraw/': typeof AuthenticatedTradeWithdrawIndexRoute
  '/settings/payment-methods/new/final-steps': typeof AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute
  '/trade/purchase/recurring/new': typeof AuthenticatedTradePurchaseRecurringNewRoute
  '/trade/withdraw/cash/payout': typeof AuthenticatedTradeWithdrawCashPayoutRoute
  '/trade/withdraw/cash/review': typeof AuthenticatedTradeWithdrawCashReviewRoute
  '/trade/withdraw/products/review': typeof AuthenticatedTradeWithdrawProductsReviewRoute
  '/trade/withdraw/products/shipping': typeof AuthenticatedTradeWithdrawProductsShippingRoute
  '/trade/withdraw/products/signature': typeof AuthenticatedTradeWithdrawProductsSignatureRoute
  '/settings/payment-methods/new/': typeof AuthenticatedSettingsPaymentMethodsNewIndexRoute
  '/trade/purchase/recurring/': typeof AuthenticatedTradePurchaseRecurringIndexRoute
  '/trade/withdraw/cash/': typeof AuthenticatedTradeWithdrawCashIndexRoute
  '/trade/withdraw/products/': typeof AuthenticatedTradeWithdrawProductsIndexRoute
  '/trade/purchase/recurring/edit/$scheduleId': typeof AuthenticatedTradePurchaseRecurringEditScheduleIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/referrals': typeof AuthenticatedReferralsRoute
  '/spreads': typeof AuthenticatedSpreadsRoute
  '/yield': typeof AuthenticatedYieldRoute
  '/email-verification': typeof UnauthenticatedEmailVerificationRoute
  '/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/sign-in': typeof UnauthenticatedSignInRoute
  '/sign-up': typeof UnauthenticatedSignUpRoute
  '/signup-interest-confirmation': typeof UnauthenticatedSignupInterestConfirmationRoute
  '/balance/premiums': typeof AuthenticatedBalancePremiumsRoute
  '/documents/activity': typeof AuthenticatedDocumentsActivityRoute
  '/documents/notification': typeof AuthenticatedDocumentsNotificationRoute
  '/documents/statement': typeof AuthenticatedDocumentsStatementRoute
  '/onboarding/$step': typeof AuthenticatedOnboardingStepRoute
  '/onboarding/docs': typeof AuthenticatedOnboardingDocsRoute
  '/onboarding/success': typeof AuthenticatedOnboardingSuccessRoute
  '/settings/cookies': typeof AuthenticatedSettingsCookiesRoute
  '/settings/mfa': typeof AuthenticatedSettingsMfaRoute
  '/settings/onboarding': typeof AuthenticatedSettingsOnboardingRoute
  '/settings/password': typeof AuthenticatedSettingsPasswordRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/trade/metal-transfer': typeof AuthenticatedTradeMetalTransferRoute
  '/balance': typeof AuthenticatedBalanceIndexRoute
  '/documents': typeof AuthenticatedDocumentsIndexRoute
  '/onboarding': typeof AuthenticatedOnboardingIndexRoute
  '/opportunities': typeof AuthenticatedOpportunitiesIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/trade': typeof AuthenticatedTradeIndexRoute
  '/opportunities/unsecured/$leaseInstance': typeof AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute
  '/settings/payment-methods/callback': typeof AuthenticatedSettingsPaymentMethodsCallbackRoute
  '/trade/pending/$taskId': typeof AuthenticatedTradePendingTaskIdRoute
  '/trade/send/vault-transfer': typeof AuthenticatedTradeSendVaultTransferRoute
  '/trade/ship-metal/packing-slip': typeof AuthenticatedTradeShipMetalPackingSlipRoute
  '/trade/ship-metal/product-list': typeof AuthenticatedTradeShipMetalProductListRoute
  '/trade/ship-metal/signature': typeof AuthenticatedTradeShipMetalSignatureRoute
  '/trade/withdraw/$': typeof AuthenticatedTradeWithdrawSplatRoute
  '/settings/payment-methods': typeof AuthenticatedSettingsPaymentMethodsIndexRoute
  '/trade/pending': typeof AuthenticatedTradePendingIndexRoute
  '/trade/purchase': typeof AuthenticatedTradePurchaseIndexRoute
  '/trade/ship-metal': typeof AuthenticatedTradeShipMetalIndexRoute
  '/trade/withdraw': typeof AuthenticatedTradeWithdrawIndexRoute
  '/settings/payment-methods/new/final-steps': typeof AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute
  '/trade/purchase/recurring/new': typeof AuthenticatedTradePurchaseRecurringNewRoute
  '/trade/withdraw/cash/payout': typeof AuthenticatedTradeWithdrawCashPayoutRoute
  '/trade/withdraw/cash/review': typeof AuthenticatedTradeWithdrawCashReviewRoute
  '/trade/withdraw/products/review': typeof AuthenticatedTradeWithdrawProductsReviewRoute
  '/trade/withdraw/products/shipping': typeof AuthenticatedTradeWithdrawProductsShippingRoute
  '/trade/withdraw/products/signature': typeof AuthenticatedTradeWithdrawProductsSignatureRoute
  '/settings/payment-methods/new': typeof AuthenticatedSettingsPaymentMethodsNewIndexRoute
  '/trade/purchase/recurring': typeof AuthenticatedTradePurchaseRecurringIndexRoute
  '/trade/withdraw/cash': typeof AuthenticatedTradeWithdrawCashIndexRoute
  '/trade/withdraw/products': typeof AuthenticatedTradeWithdrawProductsIndexRoute
  '/trade/purchase/recurring/edit/$scheduleId': typeof AuthenticatedTradePurchaseRecurringEditScheduleIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_unauthenticated': typeof UnauthenticatedRouteWithChildren
  '/_authenticated/balance': typeof AuthenticatedBalanceRouteWithChildren
  '/_authenticated/documents': typeof AuthenticatedDocumentsRouteWithChildren
  '/_authenticated/onboarding': typeof AuthenticatedOnboardingRouteWithChildren
  '/_authenticated/opportunities': typeof AuthenticatedOpportunitiesRouteWithChildren
  '/_authenticated/referrals': typeof AuthenticatedReferralsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/_authenticated/spreads': typeof AuthenticatedSpreadsRoute
  '/_authenticated/trade': typeof AuthenticatedTradeRouteWithChildren
  '/_authenticated/yield': typeof AuthenticatedYieldRoute
  '/_unauthenticated/email-verification': typeof UnauthenticatedEmailVerificationRoute
  '/_unauthenticated/forgot-password': typeof UnauthenticatedForgotPasswordRoute
  '/_unauthenticated/sign-in': typeof UnauthenticatedSignInRoute
  '/_unauthenticated/sign-up': typeof UnauthenticatedSignUpRoute
  '/_unauthenticated/signup-interest-confirmation': typeof UnauthenticatedSignupInterestConfirmationRoute
  '/_authenticated/balance/premiums': typeof AuthenticatedBalancePremiumsRoute
  '/_authenticated/documents/activity': typeof AuthenticatedDocumentsActivityRoute
  '/_authenticated/documents/notification': typeof AuthenticatedDocumentsNotificationRoute
  '/_authenticated/documents/statement': typeof AuthenticatedDocumentsStatementRoute
  '/_authenticated/onboarding/$step': typeof AuthenticatedOnboardingStepRoute
  '/_authenticated/onboarding/docs': typeof AuthenticatedOnboardingDocsRoute
  '/_authenticated/onboarding/success': typeof AuthenticatedOnboardingSuccessRoute
  '/_authenticated/settings/cookies': typeof AuthenticatedSettingsCookiesRoute
  '/_authenticated/settings/mfa': typeof AuthenticatedSettingsMfaRoute
  '/_authenticated/settings/onboarding': typeof AuthenticatedSettingsOnboardingRoute
  '/_authenticated/settings/password': typeof AuthenticatedSettingsPasswordRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/trade/metal-transfer': typeof AuthenticatedTradeMetalTransferRoute
  '/_authenticated/trade/purchase': typeof AuthenticatedTradePurchaseRouteWithChildren
  '/_authenticated/trade/ship-metal': typeof AuthenticatedTradeShipMetalRouteWithChildren
  '/_authenticated/trade/withdraw': typeof AuthenticatedTradeWithdrawRouteWithChildren
  '/_authenticated/balance/': typeof AuthenticatedBalanceIndexRoute
  '/_authenticated/documents/': typeof AuthenticatedDocumentsIndexRoute
  '/_authenticated/onboarding/': typeof AuthenticatedOnboardingIndexRoute
  '/_authenticated/opportunities/': typeof AuthenticatedOpportunitiesIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/trade/': typeof AuthenticatedTradeIndexRoute
  '/_authenticated/opportunities/unsecured/$leaseInstance': typeof AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute
  '/_authenticated/settings/payment-methods/callback': typeof AuthenticatedSettingsPaymentMethodsCallbackRoute
  '/_authenticated/trade/pending/$taskId': typeof AuthenticatedTradePendingTaskIdRoute
  '/_authenticated/trade/send/vault-transfer': typeof AuthenticatedTradeSendVaultTransferRoute
  '/_authenticated/trade/ship-metal/packing-slip': typeof AuthenticatedTradeShipMetalPackingSlipRoute
  '/_authenticated/trade/ship-metal/product-list': typeof AuthenticatedTradeShipMetalProductListRoute
  '/_authenticated/trade/ship-metal/signature': typeof AuthenticatedTradeShipMetalSignatureRoute
  '/_authenticated/trade/withdraw/$': typeof AuthenticatedTradeWithdrawSplatRoute
  '/_authenticated/settings/payment-methods/': typeof AuthenticatedSettingsPaymentMethodsIndexRoute
  '/_authenticated/trade/pending/': typeof AuthenticatedTradePendingIndexRoute
  '/_authenticated/trade/purchase/': typeof AuthenticatedTradePurchaseIndexRoute
  '/_authenticated/trade/ship-metal/': typeof AuthenticatedTradeShipMetalIndexRoute
  '/_authenticated/trade/withdraw/': typeof AuthenticatedTradeWithdrawIndexRoute
  '/_authenticated/settings/payment-methods/new/final-steps': typeof AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute
  '/_authenticated/trade/purchase/recurring/new': typeof AuthenticatedTradePurchaseRecurringNewRoute
  '/_authenticated/trade/withdraw/cash/payout': typeof AuthenticatedTradeWithdrawCashPayoutRoute
  '/_authenticated/trade/withdraw/cash/review': typeof AuthenticatedTradeWithdrawCashReviewRoute
  '/_authenticated/trade/withdraw/products/review': typeof AuthenticatedTradeWithdrawProductsReviewRoute
  '/_authenticated/trade/withdraw/products/shipping': typeof AuthenticatedTradeWithdrawProductsShippingRoute
  '/_authenticated/trade/withdraw/products/signature': typeof AuthenticatedTradeWithdrawProductsSignatureRoute
  '/_authenticated/settings/payment-methods/new/': typeof AuthenticatedSettingsPaymentMethodsNewIndexRoute
  '/_authenticated/trade/purchase/recurring/': typeof AuthenticatedTradePurchaseRecurringIndexRoute
  '/_authenticated/trade/withdraw/cash/': typeof AuthenticatedTradeWithdrawCashIndexRoute
  '/_authenticated/trade/withdraw/products/': typeof AuthenticatedTradeWithdrawProductsIndexRoute
  '/_authenticated/trade/purchase/recurring/edit/$scheduleId': typeof AuthenticatedTradePurchaseRecurringEditScheduleIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/balance'
    | '/documents'
    | '/onboarding'
    | '/opportunities'
    | '/referrals'
    | '/settings'
    | '/spreads'
    | '/trade'
    | '/yield'
    | '/email-verification'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/signup-interest-confirmation'
    | '/balance/premiums'
    | '/documents/activity'
    | '/documents/notification'
    | '/documents/statement'
    | '/onboarding/$step'
    | '/onboarding/docs'
    | '/onboarding/success'
    | '/settings/cookies'
    | '/settings/mfa'
    | '/settings/onboarding'
    | '/settings/password'
    | '/settings/profile'
    | '/trade/metal-transfer'
    | '/trade/purchase'
    | '/trade/ship-metal'
    | '/trade/withdraw'
    | '/balance/'
    | '/documents/'
    | '/onboarding/'
    | '/opportunities/'
    | '/settings/'
    | '/trade/'
    | '/opportunities/unsecured/$leaseInstance'
    | '/settings/payment-methods/callback'
    | '/trade/pending/$taskId'
    | '/trade/send/vault-transfer'
    | '/trade/ship-metal/packing-slip'
    | '/trade/ship-metal/product-list'
    | '/trade/ship-metal/signature'
    | '/trade/withdraw/$'
    | '/settings/payment-methods/'
    | '/trade/pending/'
    | '/trade/purchase/'
    | '/trade/ship-metal/'
    | '/trade/withdraw/'
    | '/settings/payment-methods/new/final-steps'
    | '/trade/purchase/recurring/new'
    | '/trade/withdraw/cash/payout'
    | '/trade/withdraw/cash/review'
    | '/trade/withdraw/products/review'
    | '/trade/withdraw/products/shipping'
    | '/trade/withdraw/products/signature'
    | '/settings/payment-methods/new/'
    | '/trade/purchase/recurring/'
    | '/trade/withdraw/cash/'
    | '/trade/withdraw/products/'
    | '/trade/purchase/recurring/edit/$scheduleId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/referrals'
    | '/spreads'
    | '/yield'
    | '/email-verification'
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/signup-interest-confirmation'
    | '/balance/premiums'
    | '/documents/activity'
    | '/documents/notification'
    | '/documents/statement'
    | '/onboarding/$step'
    | '/onboarding/docs'
    | '/onboarding/success'
    | '/settings/cookies'
    | '/settings/mfa'
    | '/settings/onboarding'
    | '/settings/password'
    | '/settings/profile'
    | '/trade/metal-transfer'
    | '/balance'
    | '/documents'
    | '/onboarding'
    | '/opportunities'
    | '/settings'
    | '/trade'
    | '/opportunities/unsecured/$leaseInstance'
    | '/settings/payment-methods/callback'
    | '/trade/pending/$taskId'
    | '/trade/send/vault-transfer'
    | '/trade/ship-metal/packing-slip'
    | '/trade/ship-metal/product-list'
    | '/trade/ship-metal/signature'
    | '/trade/withdraw/$'
    | '/settings/payment-methods'
    | '/trade/pending'
    | '/trade/purchase'
    | '/trade/ship-metal'
    | '/trade/withdraw'
    | '/settings/payment-methods/new/final-steps'
    | '/trade/purchase/recurring/new'
    | '/trade/withdraw/cash/payout'
    | '/trade/withdraw/cash/review'
    | '/trade/withdraw/products/review'
    | '/trade/withdraw/products/shipping'
    | '/trade/withdraw/products/signature'
    | '/settings/payment-methods/new'
    | '/trade/purchase/recurring'
    | '/trade/withdraw/cash'
    | '/trade/withdraw/products'
    | '/trade/purchase/recurring/edit/$scheduleId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/_unauthenticated'
    | '/_authenticated/balance'
    | '/_authenticated/documents'
    | '/_authenticated/onboarding'
    | '/_authenticated/opportunities'
    | '/_authenticated/referrals'
    | '/_authenticated/settings'
    | '/_authenticated/spreads'
    | '/_authenticated/trade'
    | '/_authenticated/yield'
    | '/_unauthenticated/email-verification'
    | '/_unauthenticated/forgot-password'
    | '/_unauthenticated/sign-in'
    | '/_unauthenticated/sign-up'
    | '/_unauthenticated/signup-interest-confirmation'
    | '/_authenticated/balance/premiums'
    | '/_authenticated/documents/activity'
    | '/_authenticated/documents/notification'
    | '/_authenticated/documents/statement'
    | '/_authenticated/onboarding/$step'
    | '/_authenticated/onboarding/docs'
    | '/_authenticated/onboarding/success'
    | '/_authenticated/settings/cookies'
    | '/_authenticated/settings/mfa'
    | '/_authenticated/settings/onboarding'
    | '/_authenticated/settings/password'
    | '/_authenticated/settings/profile'
    | '/_authenticated/trade/metal-transfer'
    | '/_authenticated/trade/purchase'
    | '/_authenticated/trade/ship-metal'
    | '/_authenticated/trade/withdraw'
    | '/_authenticated/balance/'
    | '/_authenticated/documents/'
    | '/_authenticated/onboarding/'
    | '/_authenticated/opportunities/'
    | '/_authenticated/settings/'
    | '/_authenticated/trade/'
    | '/_authenticated/opportunities/unsecured/$leaseInstance'
    | '/_authenticated/settings/payment-methods/callback'
    | '/_authenticated/trade/pending/$taskId'
    | '/_authenticated/trade/send/vault-transfer'
    | '/_authenticated/trade/ship-metal/packing-slip'
    | '/_authenticated/trade/ship-metal/product-list'
    | '/_authenticated/trade/ship-metal/signature'
    | '/_authenticated/trade/withdraw/$'
    | '/_authenticated/settings/payment-methods/'
    | '/_authenticated/trade/pending/'
    | '/_authenticated/trade/purchase/'
    | '/_authenticated/trade/ship-metal/'
    | '/_authenticated/trade/withdraw/'
    | '/_authenticated/settings/payment-methods/new/final-steps'
    | '/_authenticated/trade/purchase/recurring/new'
    | '/_authenticated/trade/withdraw/cash/payout'
    | '/_authenticated/trade/withdraw/cash/review'
    | '/_authenticated/trade/withdraw/products/review'
    | '/_authenticated/trade/withdraw/products/shipping'
    | '/_authenticated/trade/withdraw/products/signature'
    | '/_authenticated/settings/payment-methods/new/'
    | '/_authenticated/trade/purchase/recurring/'
    | '/_authenticated/trade/withdraw/cash/'
    | '/_authenticated/trade/withdraw/products/'
    | '/_authenticated/trade/purchase/recurring/edit/$scheduleId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  UnauthenticatedRoute: typeof UnauthenticatedRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_unauthenticated': {
      id: '/_unauthenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof UnauthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/balance': {
      id: '/_authenticated/balance'
      path: '/balance'
      fullPath: '/balance'
      preLoaderRoute: typeof AuthenticatedBalanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/documents': {
      id: '/_authenticated/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthenticatedDocumentsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/onboarding': {
      id: '/_authenticated/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthenticatedOnboardingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/opportunities': {
      id: '/_authenticated/opportunities'
      path: '/opportunities'
      fullPath: '/opportunities'
      preLoaderRoute: typeof AuthenticatedOpportunitiesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/referrals': {
      id: '/_authenticated/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AuthenticatedReferralsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/spreads': {
      id: '/_authenticated/spreads'
      path: '/spreads'
      fullPath: '/spreads'
      preLoaderRoute: typeof AuthenticatedSpreadsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/trade': {
      id: '/_authenticated/trade'
      path: '/trade'
      fullPath: '/trade'
      preLoaderRoute: typeof AuthenticatedTradeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/yield': {
      id: '/_authenticated/yield'
      path: '/yield'
      fullPath: '/yield'
      preLoaderRoute: typeof AuthenticatedYieldRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_unauthenticated/email-verification': {
      id: '/_unauthenticated/email-verification'
      path: '/email-verification'
      fullPath: '/email-verification'
      preLoaderRoute: typeof UnauthenticatedEmailVerificationRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/forgot-password': {
      id: '/_unauthenticated/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof UnauthenticatedForgotPasswordRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/sign-in': {
      id: '/_unauthenticated/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof UnauthenticatedSignInRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/sign-up': {
      id: '/_unauthenticated/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof UnauthenticatedSignUpRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_unauthenticated/signup-interest-confirmation': {
      id: '/_unauthenticated/signup-interest-confirmation'
      path: '/signup-interest-confirmation'
      fullPath: '/signup-interest-confirmation'
      preLoaderRoute: typeof UnauthenticatedSignupInterestConfirmationRouteImport
      parentRoute: typeof UnauthenticatedRoute
    }
    '/_authenticated/balance/': {
      id: '/_authenticated/balance/'
      path: '/'
      fullPath: '/balance/'
      preLoaderRoute: typeof AuthenticatedBalanceIndexRouteImport
      parentRoute: typeof AuthenticatedBalanceRoute
    }
    '/_authenticated/balance/premiums': {
      id: '/_authenticated/balance/premiums'
      path: '/premiums'
      fullPath: '/balance/premiums'
      preLoaderRoute: typeof AuthenticatedBalancePremiumsRouteImport
      parentRoute: typeof AuthenticatedBalanceRoute
    }
    '/_authenticated/documents/': {
      id: '/_authenticated/documents/'
      path: '/'
      fullPath: '/documents/'
      preLoaderRoute: typeof AuthenticatedDocumentsIndexRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/documents/activity': {
      id: '/_authenticated/documents/activity'
      path: '/activity'
      fullPath: '/documents/activity'
      preLoaderRoute: typeof AuthenticatedDocumentsActivityRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/documents/notification': {
      id: '/_authenticated/documents/notification'
      path: '/notification'
      fullPath: '/documents/notification'
      preLoaderRoute: typeof AuthenticatedDocumentsNotificationRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/documents/statement': {
      id: '/_authenticated/documents/statement'
      path: '/statement'
      fullPath: '/documents/statement'
      preLoaderRoute: typeof AuthenticatedDocumentsStatementRouteImport
      parentRoute: typeof AuthenticatedDocumentsRoute
    }
    '/_authenticated/onboarding/': {
      id: '/_authenticated/onboarding/'
      path: '/'
      fullPath: '/onboarding/'
      preLoaderRoute: typeof AuthenticatedOnboardingIndexRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/onboarding/$step': {
      id: '/_authenticated/onboarding/$step'
      path: '/$step'
      fullPath: '/onboarding/$step'
      preLoaderRoute: typeof AuthenticatedOnboardingStepRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/onboarding/docs': {
      id: '/_authenticated/onboarding/docs'
      path: '/docs'
      fullPath: '/onboarding/docs'
      preLoaderRoute: typeof AuthenticatedOnboardingDocsRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/onboarding/success': {
      id: '/_authenticated/onboarding/success'
      path: '/success'
      fullPath: '/onboarding/success'
      preLoaderRoute: typeof AuthenticatedOnboardingSuccessRouteImport
      parentRoute: typeof AuthenticatedOnboardingRoute
    }
    '/_authenticated/opportunities/': {
      id: '/_authenticated/opportunities/'
      path: '/'
      fullPath: '/opportunities/'
      preLoaderRoute: typeof AuthenticatedOpportunitiesIndexRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/cookies': {
      id: '/_authenticated/settings/cookies'
      path: '/cookies'
      fullPath: '/settings/cookies'
      preLoaderRoute: typeof AuthenticatedSettingsCookiesRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/mfa': {
      id: '/_authenticated/settings/mfa'
      path: '/mfa'
      fullPath: '/settings/mfa'
      preLoaderRoute: typeof AuthenticatedSettingsMfaRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/onboarding': {
      id: '/_authenticated/settings/onboarding'
      path: '/onboarding'
      fullPath: '/settings/onboarding'
      preLoaderRoute: typeof AuthenticatedSettingsOnboardingRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/password': {
      id: '/_authenticated/settings/password'
      path: '/password'
      fullPath: '/settings/password'
      preLoaderRoute: typeof AuthenticatedSettingsPasswordRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/trade/': {
      id: '/_authenticated/trade/'
      path: '/'
      fullPath: '/trade/'
      preLoaderRoute: typeof AuthenticatedTradeIndexRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/trade/metal-transfer': {
      id: '/_authenticated/trade/metal-transfer'
      path: '/metal-transfer'
      fullPath: '/trade/metal-transfer'
      preLoaderRoute: typeof AuthenticatedTradeMetalTransferRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/trade/purchase': {
      id: '/_authenticated/trade/purchase'
      path: '/purchase'
      fullPath: '/trade/purchase'
      preLoaderRoute: typeof AuthenticatedTradePurchaseRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/trade/ship-metal': {
      id: '/_authenticated/trade/ship-metal'
      path: '/ship-metal'
      fullPath: '/trade/ship-metal'
      preLoaderRoute: typeof AuthenticatedTradeShipMetalRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/trade/withdraw': {
      id: '/_authenticated/trade/withdraw'
      path: '/withdraw'
      fullPath: '/trade/withdraw'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/opportunities/unsecured/$leaseInstance': {
      id: '/_authenticated/opportunities/unsecured/$leaseInstance'
      path: '/unsecured/$leaseInstance'
      fullPath: '/opportunities/unsecured/$leaseInstance'
      preLoaderRoute: typeof AuthenticatedOpportunitiesUnsecuredLeaseInstanceRouteImport
      parentRoute: typeof AuthenticatedOpportunitiesRoute
    }
    '/_authenticated/settings/payment-methods/': {
      id: '/_authenticated/settings/payment-methods/'
      path: '/payment-methods'
      fullPath: '/settings/payment-methods/'
      preLoaderRoute: typeof AuthenticatedSettingsPaymentMethodsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/payment-methods/callback': {
      id: '/_authenticated/settings/payment-methods/callback'
      path: '/payment-methods/callback'
      fullPath: '/settings/payment-methods/callback'
      preLoaderRoute: typeof AuthenticatedSettingsPaymentMethodsCallbackRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/trade/pending/': {
      id: '/_authenticated/trade/pending/'
      path: '/pending'
      fullPath: '/trade/pending/'
      preLoaderRoute: typeof AuthenticatedTradePendingIndexRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/trade/pending/$taskId': {
      id: '/_authenticated/trade/pending/$taskId'
      path: '/pending/$taskId'
      fullPath: '/trade/pending/$taskId'
      preLoaderRoute: typeof AuthenticatedTradePendingTaskIdRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/trade/purchase/': {
      id: '/_authenticated/trade/purchase/'
      path: '/'
      fullPath: '/trade/purchase/'
      preLoaderRoute: typeof AuthenticatedTradePurchaseIndexRouteImport
      parentRoute: typeof AuthenticatedTradePurchaseRoute
    }
    '/_authenticated/trade/send/vault-transfer': {
      id: '/_authenticated/trade/send/vault-transfer'
      path: '/send/vault-transfer'
      fullPath: '/trade/send/vault-transfer'
      preLoaderRoute: typeof AuthenticatedTradeSendVaultTransferRouteImport
      parentRoute: typeof AuthenticatedTradeRoute
    }
    '/_authenticated/trade/ship-metal/': {
      id: '/_authenticated/trade/ship-metal/'
      path: '/'
      fullPath: '/trade/ship-metal/'
      preLoaderRoute: typeof AuthenticatedTradeShipMetalIndexRouteImport
      parentRoute: typeof AuthenticatedTradeShipMetalRoute
    }
    '/_authenticated/trade/ship-metal/packing-slip': {
      id: '/_authenticated/trade/ship-metal/packing-slip'
      path: '/packing-slip'
      fullPath: '/trade/ship-metal/packing-slip'
      preLoaderRoute: typeof AuthenticatedTradeShipMetalPackingSlipRouteImport
      parentRoute: typeof AuthenticatedTradeShipMetalRoute
    }
    '/_authenticated/trade/ship-metal/product-list': {
      id: '/_authenticated/trade/ship-metal/product-list'
      path: '/product-list'
      fullPath: '/trade/ship-metal/product-list'
      preLoaderRoute: typeof AuthenticatedTradeShipMetalProductListRouteImport
      parentRoute: typeof AuthenticatedTradeShipMetalRoute
    }
    '/_authenticated/trade/ship-metal/signature': {
      id: '/_authenticated/trade/ship-metal/signature'
      path: '/signature'
      fullPath: '/trade/ship-metal/signature'
      preLoaderRoute: typeof AuthenticatedTradeShipMetalSignatureRouteImport
      parentRoute: typeof AuthenticatedTradeShipMetalRoute
    }
    '/_authenticated/trade/withdraw/': {
      id: '/_authenticated/trade/withdraw/'
      path: '/'
      fullPath: '/trade/withdraw/'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawIndexRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/withdraw/$': {
      id: '/_authenticated/trade/withdraw/$'
      path: '/$'
      fullPath: '/trade/withdraw/$'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawSplatRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/settings/payment-methods/new/': {
      id: '/_authenticated/settings/payment-methods/new/'
      path: '/payment-methods/new'
      fullPath: '/settings/payment-methods/new/'
      preLoaderRoute: typeof AuthenticatedSettingsPaymentMethodsNewIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/settings/payment-methods/new/final-steps': {
      id: '/_authenticated/settings/payment-methods/new/final-steps'
      path: '/payment-methods/new/final-steps'
      fullPath: '/settings/payment-methods/new/final-steps'
      preLoaderRoute: typeof AuthenticatedSettingsPaymentMethodsNewFinalStepsRouteImport
      parentRoute: typeof AuthenticatedSettingsRoute
    }
    '/_authenticated/trade/purchase/recurring/': {
      id: '/_authenticated/trade/purchase/recurring/'
      path: '/recurring'
      fullPath: '/trade/purchase/recurring/'
      preLoaderRoute: typeof AuthenticatedTradePurchaseRecurringIndexRouteImport
      parentRoute: typeof AuthenticatedTradePurchaseRoute
    }
    '/_authenticated/trade/purchase/recurring/new': {
      id: '/_authenticated/trade/purchase/recurring/new'
      path: '/recurring/new'
      fullPath: '/trade/purchase/recurring/new'
      preLoaderRoute: typeof AuthenticatedTradePurchaseRecurringNewRouteImport
      parentRoute: typeof AuthenticatedTradePurchaseRoute
    }
    '/_authenticated/trade/withdraw/cash/': {
      id: '/_authenticated/trade/withdraw/cash/'
      path: '/cash'
      fullPath: '/trade/withdraw/cash/'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawCashIndexRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/withdraw/cash/payout': {
      id: '/_authenticated/trade/withdraw/cash/payout'
      path: '/cash/payout'
      fullPath: '/trade/withdraw/cash/payout'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawCashPayoutRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/withdraw/cash/review': {
      id: '/_authenticated/trade/withdraw/cash/review'
      path: '/cash/review'
      fullPath: '/trade/withdraw/cash/review'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawCashReviewRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/withdraw/products/': {
      id: '/_authenticated/trade/withdraw/products/'
      path: '/products'
      fullPath: '/trade/withdraw/products/'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawProductsIndexRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/withdraw/products/review': {
      id: '/_authenticated/trade/withdraw/products/review'
      path: '/products/review'
      fullPath: '/trade/withdraw/products/review'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawProductsReviewRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/withdraw/products/shipping': {
      id: '/_authenticated/trade/withdraw/products/shipping'
      path: '/products/shipping'
      fullPath: '/trade/withdraw/products/shipping'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawProductsShippingRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/withdraw/products/signature': {
      id: '/_authenticated/trade/withdraw/products/signature'
      path: '/products/signature'
      fullPath: '/trade/withdraw/products/signature'
      preLoaderRoute: typeof AuthenticatedTradeWithdrawProductsSignatureRouteImport
      parentRoute: typeof AuthenticatedTradeWithdrawRoute
    }
    '/_authenticated/trade/purchase/recurring/edit/$scheduleId': {
      id: '/_authenticated/trade/purchase/recurring/edit/$scheduleId'
      path: '/recurring/edit/$scheduleId'
      fullPath: '/trade/purchase/recurring/edit/$scheduleId'
      preLoaderRoute: typeof AuthenticatedTradePurchaseRecurringEditScheduleIdRouteImport
      parentRoute: typeof AuthenticatedTradePurchaseRoute
    }
  }
}

interface AuthenticatedBalanceRouteChildren {
  AuthenticatedBalancePremiumsRoute: typeof AuthenticatedBalancePremiumsRoute
  AuthenticatedBalanceIndexRoute: typeof AuthenticatedBalanceIndexRoute
}

const AuthenticatedBalanceRouteChildren: AuthenticatedBalanceRouteChildren = {
  AuthenticatedBalancePremiumsRoute: AuthenticatedBalancePremiumsRoute,
  AuthenticatedBalanceIndexRoute: AuthenticatedBalanceIndexRoute,
}

const AuthenticatedBalanceRouteWithChildren =
  AuthenticatedBalanceRoute._addFileChildren(AuthenticatedBalanceRouteChildren)

interface AuthenticatedDocumentsRouteChildren {
  AuthenticatedDocumentsActivityRoute: typeof AuthenticatedDocumentsActivityRoute
  AuthenticatedDocumentsNotificationRoute: typeof AuthenticatedDocumentsNotificationRoute
  AuthenticatedDocumentsStatementRoute: typeof AuthenticatedDocumentsStatementRoute
  AuthenticatedDocumentsIndexRoute: typeof AuthenticatedDocumentsIndexRoute
}

const AuthenticatedDocumentsRouteChildren: AuthenticatedDocumentsRouteChildren =
  {
    AuthenticatedDocumentsActivityRoute: AuthenticatedDocumentsActivityRoute,
    AuthenticatedDocumentsNotificationRoute:
      AuthenticatedDocumentsNotificationRoute,
    AuthenticatedDocumentsStatementRoute: AuthenticatedDocumentsStatementRoute,
    AuthenticatedDocumentsIndexRoute: AuthenticatedDocumentsIndexRoute,
  }

const AuthenticatedDocumentsRouteWithChildren =
  AuthenticatedDocumentsRoute._addFileChildren(
    AuthenticatedDocumentsRouteChildren,
  )

interface AuthenticatedOnboardingRouteChildren {
  AuthenticatedOnboardingStepRoute: typeof AuthenticatedOnboardingStepRoute
  AuthenticatedOnboardingDocsRoute: typeof AuthenticatedOnboardingDocsRoute
  AuthenticatedOnboardingSuccessRoute: typeof AuthenticatedOnboardingSuccessRoute
  AuthenticatedOnboardingIndexRoute: typeof AuthenticatedOnboardingIndexRoute
}

const AuthenticatedOnboardingRouteChildren: AuthenticatedOnboardingRouteChildren =
  {
    AuthenticatedOnboardingStepRoute: AuthenticatedOnboardingStepRoute,
    AuthenticatedOnboardingDocsRoute: AuthenticatedOnboardingDocsRoute,
    AuthenticatedOnboardingSuccessRoute: AuthenticatedOnboardingSuccessRoute,
    AuthenticatedOnboardingIndexRoute: AuthenticatedOnboardingIndexRoute,
  }

const AuthenticatedOnboardingRouteWithChildren =
  AuthenticatedOnboardingRoute._addFileChildren(
    AuthenticatedOnboardingRouteChildren,
  )

interface AuthenticatedOpportunitiesRouteChildren {
  AuthenticatedOpportunitiesIndexRoute: typeof AuthenticatedOpportunitiesIndexRoute
  AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute: typeof AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute
}

const AuthenticatedOpportunitiesRouteChildren: AuthenticatedOpportunitiesRouteChildren =
  {
    AuthenticatedOpportunitiesIndexRoute: AuthenticatedOpportunitiesIndexRoute,
    AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute:
      AuthenticatedOpportunitiesUnsecuredLeaseInstanceRoute,
  }

const AuthenticatedOpportunitiesRouteWithChildren =
  AuthenticatedOpportunitiesRoute._addFileChildren(
    AuthenticatedOpportunitiesRouteChildren,
  )

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsCookiesRoute: typeof AuthenticatedSettingsCookiesRoute
  AuthenticatedSettingsMfaRoute: typeof AuthenticatedSettingsMfaRoute
  AuthenticatedSettingsOnboardingRoute: typeof AuthenticatedSettingsOnboardingRoute
  AuthenticatedSettingsPasswordRoute: typeof AuthenticatedSettingsPasswordRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsPaymentMethodsCallbackRoute: typeof AuthenticatedSettingsPaymentMethodsCallbackRoute
  AuthenticatedSettingsPaymentMethodsIndexRoute: typeof AuthenticatedSettingsPaymentMethodsIndexRoute
  AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute: typeof AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute
  AuthenticatedSettingsPaymentMethodsNewIndexRoute: typeof AuthenticatedSettingsPaymentMethodsNewIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsCookiesRoute: AuthenticatedSettingsCookiesRoute,
  AuthenticatedSettingsMfaRoute: AuthenticatedSettingsMfaRoute,
  AuthenticatedSettingsOnboardingRoute: AuthenticatedSettingsOnboardingRoute,
  AuthenticatedSettingsPasswordRoute: AuthenticatedSettingsPasswordRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedSettingsPaymentMethodsCallbackRoute:
    AuthenticatedSettingsPaymentMethodsCallbackRoute,
  AuthenticatedSettingsPaymentMethodsIndexRoute:
    AuthenticatedSettingsPaymentMethodsIndexRoute,
  AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute:
    AuthenticatedSettingsPaymentMethodsNewFinalStepsRoute,
  AuthenticatedSettingsPaymentMethodsNewIndexRoute:
    AuthenticatedSettingsPaymentMethodsNewIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedTradePurchaseRouteChildren {
  AuthenticatedTradePurchaseIndexRoute: typeof AuthenticatedTradePurchaseIndexRoute
  AuthenticatedTradePurchaseRecurringNewRoute: typeof AuthenticatedTradePurchaseRecurringNewRoute
  AuthenticatedTradePurchaseRecurringIndexRoute: typeof AuthenticatedTradePurchaseRecurringIndexRoute
  AuthenticatedTradePurchaseRecurringEditScheduleIdRoute: typeof AuthenticatedTradePurchaseRecurringEditScheduleIdRoute
}

const AuthenticatedTradePurchaseRouteChildren: AuthenticatedTradePurchaseRouteChildren =
  {
    AuthenticatedTradePurchaseIndexRoute: AuthenticatedTradePurchaseIndexRoute,
    AuthenticatedTradePurchaseRecurringNewRoute:
      AuthenticatedTradePurchaseRecurringNewRoute,
    AuthenticatedTradePurchaseRecurringIndexRoute:
      AuthenticatedTradePurchaseRecurringIndexRoute,
    AuthenticatedTradePurchaseRecurringEditScheduleIdRoute:
      AuthenticatedTradePurchaseRecurringEditScheduleIdRoute,
  }

const AuthenticatedTradePurchaseRouteWithChildren =
  AuthenticatedTradePurchaseRoute._addFileChildren(
    AuthenticatedTradePurchaseRouteChildren,
  )

interface AuthenticatedTradeShipMetalRouteChildren {
  AuthenticatedTradeShipMetalPackingSlipRoute: typeof AuthenticatedTradeShipMetalPackingSlipRoute
  AuthenticatedTradeShipMetalProductListRoute: typeof AuthenticatedTradeShipMetalProductListRoute
  AuthenticatedTradeShipMetalSignatureRoute: typeof AuthenticatedTradeShipMetalSignatureRoute
  AuthenticatedTradeShipMetalIndexRoute: typeof AuthenticatedTradeShipMetalIndexRoute
}

const AuthenticatedTradeShipMetalRouteChildren: AuthenticatedTradeShipMetalRouteChildren =
  {
    AuthenticatedTradeShipMetalPackingSlipRoute:
      AuthenticatedTradeShipMetalPackingSlipRoute,
    AuthenticatedTradeShipMetalProductListRoute:
      AuthenticatedTradeShipMetalProductListRoute,
    AuthenticatedTradeShipMetalSignatureRoute:
      AuthenticatedTradeShipMetalSignatureRoute,
    AuthenticatedTradeShipMetalIndexRoute:
      AuthenticatedTradeShipMetalIndexRoute,
  }

const AuthenticatedTradeShipMetalRouteWithChildren =
  AuthenticatedTradeShipMetalRoute._addFileChildren(
    AuthenticatedTradeShipMetalRouteChildren,
  )

interface AuthenticatedTradeWithdrawRouteChildren {
  AuthenticatedTradeWithdrawSplatRoute: typeof AuthenticatedTradeWithdrawSplatRoute
  AuthenticatedTradeWithdrawIndexRoute: typeof AuthenticatedTradeWithdrawIndexRoute
  AuthenticatedTradeWithdrawCashPayoutRoute: typeof AuthenticatedTradeWithdrawCashPayoutRoute
  AuthenticatedTradeWithdrawCashReviewRoute: typeof AuthenticatedTradeWithdrawCashReviewRoute
  AuthenticatedTradeWithdrawProductsReviewRoute: typeof AuthenticatedTradeWithdrawProductsReviewRoute
  AuthenticatedTradeWithdrawProductsShippingRoute: typeof AuthenticatedTradeWithdrawProductsShippingRoute
  AuthenticatedTradeWithdrawProductsSignatureRoute: typeof AuthenticatedTradeWithdrawProductsSignatureRoute
  AuthenticatedTradeWithdrawCashIndexRoute: typeof AuthenticatedTradeWithdrawCashIndexRoute
  AuthenticatedTradeWithdrawProductsIndexRoute: typeof AuthenticatedTradeWithdrawProductsIndexRoute
}

const AuthenticatedTradeWithdrawRouteChildren: AuthenticatedTradeWithdrawRouteChildren =
  {
    AuthenticatedTradeWithdrawSplatRoute: AuthenticatedTradeWithdrawSplatRoute,
    AuthenticatedTradeWithdrawIndexRoute: AuthenticatedTradeWithdrawIndexRoute,
    AuthenticatedTradeWithdrawCashPayoutRoute:
      AuthenticatedTradeWithdrawCashPayoutRoute,
    AuthenticatedTradeWithdrawCashReviewRoute:
      AuthenticatedTradeWithdrawCashReviewRoute,
    AuthenticatedTradeWithdrawProductsReviewRoute:
      AuthenticatedTradeWithdrawProductsReviewRoute,
    AuthenticatedTradeWithdrawProductsShippingRoute:
      AuthenticatedTradeWithdrawProductsShippingRoute,
    AuthenticatedTradeWithdrawProductsSignatureRoute:
      AuthenticatedTradeWithdrawProductsSignatureRoute,
    AuthenticatedTradeWithdrawCashIndexRoute:
      AuthenticatedTradeWithdrawCashIndexRoute,
    AuthenticatedTradeWithdrawProductsIndexRoute:
      AuthenticatedTradeWithdrawProductsIndexRoute,
  }

const AuthenticatedTradeWithdrawRouteWithChildren =
  AuthenticatedTradeWithdrawRoute._addFileChildren(
    AuthenticatedTradeWithdrawRouteChildren,
  )

interface AuthenticatedTradeRouteChildren {
  AuthenticatedTradeMetalTransferRoute: typeof AuthenticatedTradeMetalTransferRoute
  AuthenticatedTradePurchaseRoute: typeof AuthenticatedTradePurchaseRouteWithChildren
  AuthenticatedTradeShipMetalRoute: typeof AuthenticatedTradeShipMetalRouteWithChildren
  AuthenticatedTradeWithdrawRoute: typeof AuthenticatedTradeWithdrawRouteWithChildren
  AuthenticatedTradeIndexRoute: typeof AuthenticatedTradeIndexRoute
  AuthenticatedTradePendingTaskIdRoute: typeof AuthenticatedTradePendingTaskIdRoute
  AuthenticatedTradeSendVaultTransferRoute: typeof AuthenticatedTradeSendVaultTransferRoute
  AuthenticatedTradePendingIndexRoute: typeof AuthenticatedTradePendingIndexRoute
}

const AuthenticatedTradeRouteChildren: AuthenticatedTradeRouteChildren = {
  AuthenticatedTradeMetalTransferRoute: AuthenticatedTradeMetalTransferRoute,
  AuthenticatedTradePurchaseRoute: AuthenticatedTradePurchaseRouteWithChildren,
  AuthenticatedTradeShipMetalRoute:
    AuthenticatedTradeShipMetalRouteWithChildren,
  AuthenticatedTradeWithdrawRoute: AuthenticatedTradeWithdrawRouteWithChildren,
  AuthenticatedTradeIndexRoute: AuthenticatedTradeIndexRoute,
  AuthenticatedTradePendingTaskIdRoute: AuthenticatedTradePendingTaskIdRoute,
  AuthenticatedTradeSendVaultTransferRoute:
    AuthenticatedTradeSendVaultTransferRoute,
  AuthenticatedTradePendingIndexRoute: AuthenticatedTradePendingIndexRoute,
}

const AuthenticatedTradeRouteWithChildren =
  AuthenticatedTradeRoute._addFileChildren(AuthenticatedTradeRouteChildren)

interface AuthenticatedRouteChildren {
  AuthenticatedBalanceRoute: typeof AuthenticatedBalanceRouteWithChildren
  AuthenticatedDocumentsRoute: typeof AuthenticatedDocumentsRouteWithChildren
  AuthenticatedOnboardingRoute: typeof AuthenticatedOnboardingRouteWithChildren
  AuthenticatedOpportunitiesRoute: typeof AuthenticatedOpportunitiesRouteWithChildren
  AuthenticatedReferralsRoute: typeof AuthenticatedReferralsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
  AuthenticatedSpreadsRoute: typeof AuthenticatedSpreadsRoute
  AuthenticatedTradeRoute: typeof AuthenticatedTradeRouteWithChildren
  AuthenticatedYieldRoute: typeof AuthenticatedYieldRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBalanceRoute: AuthenticatedBalanceRouteWithChildren,
  AuthenticatedDocumentsRoute: AuthenticatedDocumentsRouteWithChildren,
  AuthenticatedOnboardingRoute: AuthenticatedOnboardingRouteWithChildren,
  AuthenticatedOpportunitiesRoute: AuthenticatedOpportunitiesRouteWithChildren,
  AuthenticatedReferralsRoute: AuthenticatedReferralsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
  AuthenticatedSpreadsRoute: AuthenticatedSpreadsRoute,
  AuthenticatedTradeRoute: AuthenticatedTradeRouteWithChildren,
  AuthenticatedYieldRoute: AuthenticatedYieldRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface UnauthenticatedRouteChildren {
  UnauthenticatedEmailVerificationRoute: typeof UnauthenticatedEmailVerificationRoute
  UnauthenticatedForgotPasswordRoute: typeof UnauthenticatedForgotPasswordRoute
  UnauthenticatedSignInRoute: typeof UnauthenticatedSignInRoute
  UnauthenticatedSignUpRoute: typeof UnauthenticatedSignUpRoute
  UnauthenticatedSignupInterestConfirmationRoute: typeof UnauthenticatedSignupInterestConfirmationRoute
}

const UnauthenticatedRouteChildren: UnauthenticatedRouteChildren = {
  UnauthenticatedEmailVerificationRoute: UnauthenticatedEmailVerificationRoute,
  UnauthenticatedForgotPasswordRoute: UnauthenticatedForgotPasswordRoute,
  UnauthenticatedSignInRoute: UnauthenticatedSignInRoute,
  UnauthenticatedSignUpRoute: UnauthenticatedSignUpRoute,
  UnauthenticatedSignupInterestConfirmationRoute:
    UnauthenticatedSignupInterestConfirmationRoute,
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(
  UnauthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  UnauthenticatedRoute: UnauthenticatedRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
